import script from "./ProductCourseLessonDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCourseLessonDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProductCourseLessonDialog.vue?vue&type=style&index=0&id=3e2ba07c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e2ba07c"]])

export default __exports__